export default __webpack_public_path__ + "plant-leaf-with-white-details.png";